import { Alert, Heading, LoadingMask, Spacer } from '@zillow/constellation-10';

import {
  ErrorMessageConstants,
  LoadingConstants,
  PermissionCheck,
  USER_MANAGEMENT_APPLICATION_PERMISSION_PAGE,
} from '@zg-rentals/rental-manager-env';

import ApplicationManager from './ApplicationManager';
import ApplicationUsers from './ApplicationUsers';
import { applicationPermissionsHeadingStyles } from './StyledComponents';
import { useApplicationPermissions } from '../../hooks/useApplicationPermissions';

const ApplicationPermissionsPage = () => {
  const { loadingState, error } = useApplicationPermissions();
  return (
    <PermissionCheck route={USER_MANAGEMENT_APPLICATION_PERMISSION_PAGE}>
      <Spacer css={{ paddingInline: 'sm' }}>
        <Heading className={applicationPermissionsHeadingStyles} level={5}>
          Application Permissions
        </Heading>
        <LoadingMask loading={loadingState === LoadingConstants.INITIAL || loadingState === LoadingConstants.ERROR}>
          {error && (
            <Spacer css={{ marginBlockEnd: 'sm' }}>
              <Alert tone="critical">{`${ErrorMessageConstants.DEFAULT_ERROR} ${error}`}</Alert>
            </Spacer>
          )}
          <ApplicationManager />
          <ApplicationUsers />
        </LoadingMask>
      </Spacer>
    </PermissionCheck>
  );
};

export default ApplicationPermissionsPage;
